<template>
  <div>
    <!-- loader -->
    <!-- <div class="loader-wrapper">
      <div id="loader">
        <div id="shadow"></div>
        <div id="box"></div>
      </div>
    </div> -->
    <!-- loader end -->

   
    <!-- home section -->
    <section class="img-scence-bg-q1 home">
      <div class="animation-circle-inverse">
        <i></i>
        <i></i>
        <i></i>
      </div>
      <div class="animation-circle-inverse absolute">
        <i></i>
        <i></i>
        <i></i>
      </div>
      <div class="container">
        <div class="menu">
          <router-link to="/menu1">    <img 
                  src="../assets/images/menu.png"
                  alt="top5"
                  class="img-fluid"
                  style="width: 100px;"
                /></router-link>
              </div>
              <div class="menu-back">
                <a @click="playsound();$router.go(-1);">
<img
                  src="../assets/images/menu-back.png"
                  alt="top5"
                  class="img-fluid"
                  style="width: 80px;"
                />
</a>
              </div>
              <div class="menu-next">
                <router-link to="/menu1-video-clip">
                <img @click="playsound"
                  src="../assets/images/menu-next.png"
                  alt="top5"
                  class="img-fluid"
                  style="width: 80px;"
                />
                </router-link>
              </div>
              <div class="row justify-content-center" >
       
        
            
       <div class="col-md-6" >
      
         <div class="img-q-right" v-if="state==1">
          <h3 v-html="q1"></h3>
<br><br>
          <b-button size="lg" block  pill variant="outline-primary" v-for="data in answer1" :key="data.id" @click="answerEnter(state,data.id)">{{data.text}}</b-button>
         </div>
         <div class="img-q-right" v-else-if="state==11">
          <h3 v-html="q1"></h3>
<br><br>
          <b-button size="lg" block  pill :variant="data.variant" v-for="data in answer1" :key="data.id" disabled>{{data.text}}</b-button>
         </div>
         <div class="img-q-right" v-else-if="state==2">
          <h3 v-html="q2"></h3>
          <b-button size="lg" block  pill variant="outline-primary" v-for="data in answer2" :key="data.id" @click="answerEnter(state,data.id)">{{data.text}}</b-button>
         </div>
         <div class="img-q-right" v-else-if="state==22">
          <h3 v-html="q2"></h3>
          <b-button size="lg" block  pill :variant="data.variant" v-for="data in answer2" :key="data.id" disabled>{{data.text}}</b-button>
         </div>
         <div class="img-q-right" v-else-if="state==3">
          <h3 v-html="q3"></h3>
          <b-button size="lg" block  pill variant="outline-primary" v-for="data in answer3" :key="data.id" @click="answerEnter(state,data.id)">{{data.text}}</b-button>
         </div>
         <div class="img-q-right" v-else-if="state==33">
          <h3 v-html="q3"></h3>
          <b-button size="lg" block  pill :variant="data.variant" v-for="data in answer3" :key="data.id" disabled>{{data.text}}</b-button>
         </div>
         <div class="img-q-right" v-else-if="state==4">
          <h1 class="text-center" style="margin-top:120px;color:blue">ตอบถูก  {{score}} ข้อ</h1>
      
         </div>
        
       </div>
      
     
     </div>
      </div>
      
    </section>
    <!-- home section end -->

  
    <!--Footer Section End-->
  </div>
</template>
<script>
import InnerImageZoom from 'vue-inner-image-zoom';
import 'vue-inner-image-zoom/lib/vue-inner-image-zoom.css';
import $ from "jquery";
export default {
  components: {
    'inner-image-zoom': InnerImageZoom
  },
  data() {
    return {
      text: "sss",
      score: 0,
      responsiveNav: false,
      responsiveOthePageslist: false,
      responsiveBlogList: false,
      state:1,
      variant: 'outline-primary',
      q1: "ในฉากภาพนี้ มีกลุ่มวัฒนธรรมใดบ้าง",
      answer1 : [
        {id:1,text: 'ก.มลายู ไทยพุทธ จีน มาเลเซีย' , result: 'incorrect', variant: 'outline-primary'},
        {id:2,text: 'ข.ไทยพุทธ จีน มลายู แรงงานข้ามชาติ' , result: 'correct', variant: 'outline-primary'},
        {id:3,text: 'ค.แรงงานข้ามชาติ มลายู มาเลเซีย ไทยพุทธ ' , result: 'incorrect', variant: 'outline-primary'},
        {id:4,text: 'ง.จีน มลายู ไทยพุทธ อีสาน' , result: 'incorrect', variant: 'outline-primary'},
      ],
      q2: "ข้อใด<b><u>จับคู่</u></b>กลุ่มวัฒนธรรมกับกิจกรรมเฉพาะกลุ่มได้ถูกต้อง",
      answer2 : [
        {id:1,text: 'ก.ไทยพุทธ-วัด' , result: 'incorrect', variant: 'outline-primary'},
        {id:2,text: 'ข.ไทยจีน-ศาลเจ้า' , result: 'incorrect', variant: 'outline-primary'},
        {id:3,text: 'ค.ไทยพุทธ-ตักบาตร' , result: 'correct', variant: 'outline-primary'},
        {id:4,text: 'ง.ไทยมุสลิม-มัสยิด' , result: 'incorrect', variant: 'outline-primary'},
      ],
      q3: "ข้อใด<b><u>จับกลุ่ม</u></b>วัฒนธรรมกับกิจกรรมเฉพาะกลุ่มได้ถูกต้อง",
      answer3 : [
        {id:1,text: 'ก.ไทยมุสลิม-ละหมาด-กล่าวสลาม' , result: 'correct', variant: 'outline-primary'},
        {id:2,text: 'ข.ไทยพุทธ-ตักบาตร-ไหว้เจ้า' , result: 'incorrect', variant: 'outline-primary'},
        {id:3,text: 'ค.ไทยจีน-ให้ทาน-ไหว้พระ' , result: 'incorrect', variant: 'outline-primary'},
        {id:4,text: 'ง.ไทยจีน-ตักบาตร-บริจาค' , result: 'incorrect', variant: 'outline-primary'},
      ]
    };
  },
  mounted() {
   // this.loader();
   
  },
  methods: {
    changeScreen(state){
      var v = this;
      setTimeout(function () { (v.state = state) }, 1000);
    
    },
    playsound(){
      var audio = new Audio('./click.mp3');
				audio.play();
    },
    answerEnter(state,id) {
      var audio = new Audio('./click.mp3');
				audio.play();
      if(state == 1){
        this.state = 11
        const resultData = this.answer1.filter((item) => item.id == id );
      console.log(resultData[0].variant)
    
      if(resultData[0].result == 'incorrect'){
  
       const objIndex = this.answer1.findIndex(obj => obj.id == id);
        this.answer1[objIndex].variant = "warning"
       
      } else if(resultData[0].result == 'correct'){
        this.score++
        const objIndex = this.answer1.findIndex(obj => obj.id == id);
        this.answer1[objIndex].variant = "success"
  
 }
   this.changeScreen(2)

      }
      else if(state == 2){
        this.state = 22
        const resultData = this.answer2.filter((item) => item.id == id );
      console.log(resultData[0].variant)
    
      if(resultData[0].result == 'incorrect'){
  
       const objIndex = this.answer2.findIndex(obj => obj.id == id);
        this.answer2[objIndex].variant = "warning"
       
      } else if(resultData[0].result == 'correct'){
        this.score++
        const objIndex = this.answer2.findIndex(obj => obj.id == id);
        this.answer2[objIndex].variant = "success"
  
 }
   this.changeScreen(3)
      }
      else if(state == 3){
       this.state = 33 
       const resultData = this.answer3.filter((item) => item.id == id );
      console.log(resultData[0].variant)
    
      if(resultData[0].result == 'incorrect'){
  
       const objIndex = this.answer3.findIndex(obj => obj.id == id);
        this.answer3[objIndex].variant = "warning"
       
      } else if(resultData[0].result == 'correct'){
        this.score++
        const objIndex = this.answer3.findIndex(obj => obj.id == id);
        this.answer3[objIndex].variant = "success"
  
 }
   this.changeScreen(4)
       
      }
   
      

    },
    
    loader() {
      $(document).ready(function () {
        $(window).on("load", function () {
          $(".loader-wrapper").fadeOut("slow");
          $(".loader-wrapper").remove("slow");
        });
      });
    },
    toggleNavbar(toToggle) {
      if (toToggle === "navbar") {
        this.responsiveNav = !this.responsiveNav;
      } else if (toToggle === "blogList") {
        this.responsiveBlogList = !this.responsiveBlogList;
      } else if (toToggle === "otherPagesList") {
        this.responsiveOthePageslist = !this.responsiveOthePageslist;
      }
    },
  },
  beforeCreate: function () {
    document.body.className = "landing-page";
  },
};
</script>
<style scoped>
.navbar {
  position: absolute;
}
</style>
